<div class="step-label">
  <span>{{ pageCounterLabel }} </span>
  <span>{{ currentPage }} </span>
  <span>{{ pageCounterOfLabel }}</span>
  <span>{{ totalPages }} </span>
</div>
